import React from "react";

import { Logo } from "../Logo/Logo.component";

import { Container } from "./Header.styles";

export const Header: React.FC = () => {
  return (
    <Container>
      <Logo />
    </Container>
  );
};
